<template>
  <v-dialog v-model="dialog" persistent width="700">
    <v-card>
      <!-- Cabecera del formulario -->
      <v-card-title class="headline">
        <v-flex xs9>
          <v-icon>add</v-icon> Asignación de horarios por unidad
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <!-- Cuerpo del formulario -->
      <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md style="min-width:100%" class="py-0 px-3">
            <v-layout wrap row>
              <v-flex md12>
                <v-autocomplete
                  class="text-field-reducido"
                  :items="unidades"
                  :item-value="val => parseInt(val.id)"
                  :item-text="val => val.nombre_unidad"
                  label="Seleccione la unidad/área"
                  v-model="form.id_unidad"
                  :rules="$validate(['required'])"
                  required
                  :loading="loading"
                  outline
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12>
                <v-radio-group
                  class="text-field-reducido"
                  v-model="tipo_asignacion"
                  @change="obtenerHorarios(tipo_asignacion)"
                >
                  <v-layout row wrap>
                    <v-flex xs12 sm6 md6
                      ><v-radio label="Continuo" value="1"></v-radio
                    ></v-flex>
                    <v-flex xs12 sm6 md6
                      ><v-radio label="Discontinuo" value="2"></v-radio
                    ></v-flex>
                  </v-layout>
                </v-radio-group>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  class="text-field-reducido"
                  type="date"
                  :rules="$validate(['required'])"
                  required
                  v-model="form.fecha_desde"
                  label="Fecha de inicio"
                  outline
                  clearable
                />
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  class="text-field-reducido"
                  type="date"
                  :rules="$validate(['required'])"
                  required
                  v-model="form.fecha_hasta"
                  label="Fecha de finalización"
                  outline
                  clearable
                />
              </v-flex>
              <v-flex
                v-if="tipo_asignacion"
                :class="tipo_asignacion == '1' ? 'md12' : 'md6'"
              >
                <v-autocomplete
                  class="text-field-reducido"
                  :items="horarios"
                  :item-value="val => parseInt(val.id)"
                  :item-text="
                    val =>
                      val.descripcion +
                      ': ' +
                      val.hora_inicio +
                      ' - ' +
                      val.hora_fin
                  "
                  :label="
                    tipo_asignacion === '1'
                      ? 'Seleccione horario'
                      : 'Seleccione primer horario'
                  "
                  v-model="form.id_horario"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex md6 v-if="tipo_asignacion === '2'">
                <v-autocomplete
                  class="text-field-reducido"
                  :items="horarios2"
                  :item-value="val => parseInt(val.id)"
                  :item-text="
                    val =>
                      val.descripcion +
                      ': ' +
                      val.hora_inicio +
                      ' - ' +
                      val.hora_fin
                  "
                  label="Seleccione segundo horario"
                  v-model="form.id_horario2"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                ></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <small class="error--text text-required"
            >* Los campos son obligatorios</small
          >
          <v-spacer></v-spacer>
          <v-btn @click.native="close()">
            <v-icon>cancel</v-icon> {{ $t("common.cancel") }}
          </v-btn>
          <v-btn
            color="primary"
            type="submit"
            :loading="loading"
            :disabled="!valid"
          >
            <v-icon dark>check</v-icon> {{ $t("common.save") }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  // Definición de mixins importados
  mixins: [validate],
  // Variables iniciales
  data() {
    return {
      dialog: false,
      form: {},
      valid: false,
      loading: false,
      horarios: [],
      horarios2: [],
      unidades: [],
      tipo_asignacion: "1",
      user: this.$storage.get("user")
    };
  },
  async mounted() {
    await this.obtenerHorarios(1);
    await this.obtenerUnidades();
    this.$bus.$on("openDialogAsignarHorario", () => {
      this.tipo_asignacion = "1";
      this.form = {
        fecha_desde: this.$moment().format("YYYY-MM-DD"),
        fecha_hasta: this.$moment()
          .add(1, "year")
          .format("YYYY-MM-DD")
      };
      this.dialog = true;
    });
  },
  methods: {
    async obtenerHorarios(tipo_horario) {
      try {
        let tipo_jornada = "C";
        if (tipo_horario) {
          if (tipo_horario == 2) {
            tipo_jornada = "D1";
            let respuesta = await this.$service.graphql({
              query: `
						query{
							horarios(jornada:"D2"){
								rows{
									id
									descripcion
									hora_inicio
									hora_fin
								}
							}
						}
					`
            });
            this.horarios2 = respuesta.horarios.rows;
          }
          let res = await this.$service.graphql({
            query: `
						query{
							horarios(jornada:"${tipo_jornada}"){
								rows{
									id
									descripcion
									hora_inicio
									hora_fin
								}
							}
						}
					`
          });
          this.horarios = res.horarios.rows;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async obtenerUnidades() {
      try {
        let res = await this.$service.graphql({
          query: `
						query{
							unidads(id_estado: 17, id_entidad: 35){
								rows{
									id
									nombre_unidad
								}
							}
						}
					`
        });
        this.unidades = res.unidads.rows;
        let elemento = {
          id: -1,
          nombre_unidad: "MINISTERIO DE ECONOMÍA Y FINANZAS PÚBLICAS"
        };
        
       
        this.unidades.push(elemento);
      } catch (error) {
        console.log(error);
      }
    },
    close() {
      this.form = {};
      this.loading = false;
      this.valid = false;
      this.$bus.$emit("closeDialogAsignacionHorario");
      this.dialog = false;
    },
    async save() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          var vec_horarios = [];
          // Construimos array de horarios para la funcion
          if (this.tipo_asignacion == "1") {
            // CONTINUO
            vec_horarios = JSON.stringify([this.form.id_horario]);
          } else {
            // DISCONTINUO
            vec_horarios = JSON.stringify([
              this.form.id_horario,
              this.form.id_horario2
            ]);
          }
          //asignar horario  a todo el mefp
          if (parseInt(this.form.id_unidad) == -1) {
            // ASIGNA HORARIO PARA TODO EL MINISTERIO TANTO PARA DISCONTINUO O CONTINUO
            var query = `select control.fn_asigna_horario_todo_mefp (array ${vec_horarios},'${this.form.fecha_desde}','${this.form.fecha_hasta}', ${this.user.id})`;
            let res = await this.$service.graphql({
              query: `
                query{
                  runQuery(consulta: "${query}"){
                    respuesta
                  }
                }
              `
            });
            let respuesta = res.runQuery.respuesta[0].fn_asigna_horario_todo_mefp.split(
              "|"
            );
            if (respuesta[0] === "1") {
              this.$message.success();
              this.close();
              this.$bus.$emit("closeDialog");
            } else {
              this.$message.error(respuesta);
            }
          } else {
            // ASIGNA HORARIO POR UNIDAD TANTO PARA DISCONTINUO O CONTINUO
            var query = `select control.fn_asigna_horario_por_unidad (${this.form.id_unidad},array ${vec_horarios},'${this.form.fecha_desde}','${this.form.fecha_hasta}', ${this.user.id})`;
            let res = await this.$service.graphql({
              query: `
                query{
                  runQuery(consulta: "${query}"){
                    respuesta
                  }
                }
              `
            });
            let respuesta = res.runQuery.respuesta[0].fn_asigna_horario_por_unidad.split(
              "|"
            );
            if (respuesta[0] === "1") {
              this.$message.success();
              this.close();
              this.$bus.$emit("closeDialog");
            } else {
              this.$message.error(respuesta);
            }
          }
          this.loading = false;
        } catch (error) {
          console.log(error);
        }
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/asignacion_horario/dialogs/AsignarHorario.vue